import axios from "axios";
import { CommissionHistoryActions } from "./commissionHistoryAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

//get all Commission History api
export const getAllCommissionHistoryAsync = (search, searchText) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      let {
        skip,
        limit,
        status,
        commission_type,
        searchText,
        fromDate,
        toDate,
      } = getState().commissionHistory;
      dispatch(CommissionHistoryActions.getAllCommissionHistoryStart());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/commissionHistory/getAllCommissionHistory`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          search: searchText,
          skip,
          limit,
          status: status?.value,
          commission_type: commission_type?.value,
          fromDate,
          toDate,
        },
      });
      if (data.statusCode === 200) {
        return dispatch(
          CommissionHistoryActions.getAllCommissionHistorySuccess(data)
        );
      }
      dispatch(CommissionHistoryActions.getAllCommissionHistoryError());
    } catch (error) {
      dispatch(CommissionHistoryActions.getAllCommissionHistoryError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const getCommissionHistoryAsync = (transactionId) => {
  return async (dispatch) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;
      const token = process.env.REACT_APP_AUTH_TOKEN; // Replace with the actual token logic

      dispatch(CommissionHistoryActions.getCommissionHistoryStart());

      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/commissionHistory/getCommissionHistory/${transactionId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (data.statusCode === 200) {
        return dispatch(
          CommissionHistoryActions.getCommissionHistorySuccess(data)
        );
      }

      dispatch(CommissionHistoryActions.getCommissionHistoryError());
      dispatch(
        showSuccessSnackbar(
          "error",
          "Failed to fetch transaction details",
          3000
        )
      );
    } catch (error) {
      dispatch(CommissionHistoryActions.getCommissionHistoryError());
      dispatch(
        showSuccessSnackbar(
          "error",
          "Error while fetching transaction details",
          3000
        )
      );
    }
  };
};
